import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import ConnectGate from '../components/dashboard/ConnectGate';
import ChainGuard from '../components/dashboard/ChainGuard';
import DashboardNav from '../components/dashboard/DashboardNav';
import NotDeployedBanner from '../components/dashboard/NotDeployedBanner';

const Dashboard = () => {
  useEffect(() => {
    document.body.classList.add('db-body');
    return () => document.body.classList.remove('db-body');
  }, []);

  return (
    <div className="db-shell">
      <ConnectGate>
        <DashboardNav />
        <main className="db-main">
          <div className="container">
            <NotDeployedBanner />
            <ChainGuard>
              <Outlet />
            </ChainGuard>
          </div>
        </main>
      </ConnectGate>
    </div>
  );
};

export default Dashboard;
